<script>
import { mixins, Radar } from 'vue-chartjs'
import chartSkillsLabels from '@/locales/chartSkillsLabels'

export default {
    name: 'RadarChart',
    extends: Radar,
    props: ['chartData', "labels"],
    mounted(){
        this.renderChart(this.dataChart, this.options)
    },
    computed: {
        dataChart(){
            return { labels: this.labels, datasets: this.chartData }
        },
        currentLocale(){
            return this.$i18n.locale
        }

    },
    data(){
        return {

            options: {
                startAngle: 0,
                layout: {
                    padding: 20,
                },
                legend: {
                    display: true,
                    position: "top",
                    labels: {
                         fontSize: 14,
                         fontStyle: "bold"
                    }
                },
                elements: {
                    line: {
                        tension: 0
                    }
                },
                scale: {
                    reverse: false,
                    gridLines: {
                        circular: false,
                        lineWidth: 1,
                        color: "#DCDDDC"
                    },
                    angleLines: {
                        lineWidth: 3,
                        color: "#DCDDDC"
                    },
                    ticks: {
                        beginAtZero: true,
                        stepSize: 1,
                        max: 5,

                    },
                    pointLabels: {
                        fontColor: "#929CAA",
                        fontFamily: "'Popins', sans-serif",
                        fontSize: 12,
                        fontStyle: "bold",
                        callback: function(value, index, ticks) {
                            const re = /\b[\wéèà']+(?:[^\w\n]+[\wéèà']+){0,2}\b/g;
                            // console.log(value.match(re))
                            // const wordList = sample.match(re);
                            if(value.match(re).length > 1){
                                return value.match(re);
                            }else{
                                return value
                            }
                        }
                    }
                }
            }
        }
    },
    watch: {
        'chartData': {
            handler: function (newData, oldData) {
                this.$data._chart.update()
                this.renderChart(this.dataChart, this.options)

            },
        },
        'labels': {
            handler: function (newData, oldData) {
                this.$data._chart.update()
                this.renderChart(this.dataChart, this.options)
            },
        }
    }

}
</script>





